"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitCaseRequestApiDomain = void 0;
const core_1 = require("@js-joda/core");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const service_1 = require("../../../service");
const utils_1 = require("../../../utils");
const common_1 = require("../common");
const regex_1 = require("../common/regex");
class SubmitCaseRequestApiDomain extends service_1.ServiceRequestBodyApiDomain {
    constructor(props) {
        super();
        Object.assign(this, props);
    }
}
exports.SubmitCaseRequestApiDomain = SubmitCaseRequestApiDomain;
__decorate([
    (0, utils_1.IsSanitizedHtml)({
        isOptional: true,
        maxLength: 50000,
        sanitizeHtmlOptions: { allowedTags: [] },
    }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(common_1.Category),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(common_1.SubCategory),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "subCategory", void 0);
__decorate([
    (0, utils_1.IsString)({ isOptional: true, maxLength: 10 }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "incidentBlockOrStreetNo", void 0);
__decorate([
    (0, utils_1.IsString)({ isOptional: true, maxLength: 100, regExp: [RegExp(regex_1.Regex.STREET_NAME)] }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "incidentStreetName", void 0);
__decorate([
    (0, utils_1.IsString)({ isOptional: true, maxLength: 3 }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "incidentLevel", void 0);
__decorate([
    (0, utils_1.IsString)({ isOptional: true, maxLength: 5 }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "incidentUnit", void 0);
__decorate([
    (0, utils_1.IsNumber)(),
    __metadata("design:type", Number)
], SubmitCaseRequestApiDomain.prototype, "x", void 0);
__decorate([
    (0, utils_1.IsNumber)(),
    __metadata("design:type", Number)
], SubmitCaseRequestApiDomain.prototype, "y", void 0);
__decorate([
    (0, utils_1.IsSGPostalCode)({ isOptional: true }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "incidentPostalCode", void 0);
__decorate([
    (0, utils_1.IsNumber)(),
    __metadata("design:type", Number)
], SubmitCaseRequestApiDomain.prototype, "lat", void 0);
__decorate([
    (0, utils_1.IsNumber)(),
    __metadata("design:type", Number)
], SubmitCaseRequestApiDomain.prototype, "lng", void 0);
__decorate([
    (0, utils_1.IsSanitizedHtml)({
        isOptional: true,
        maxLength: 160,
        sanitizeHtmlOptions: { allowedTags: [] },
    }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "incidentLocationDescription", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(utils_1.ClassTransformers.ZonedDateTimeClassTransformer),
    __metadata("design:type", core_1.ZonedDateTime)
], SubmitCaseRequestApiDomain.prototype, "incidentDateTime", void 0);
__decorate([
    (0, utils_1.IsEmail)({ isOptional: true, maxLength: 320 }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "customerEmail", void 0);
__decorate([
    (0, utils_1.IsSGPhoneNumber)({ isOptional: true }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "customerMobileNo", void 0);
__decorate([
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(3),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => common_1.SubmitCaseAttachmentDomain),
    __metadata("design:type", Array)
], SubmitCaseRequestApiDomain.prototype, "attachments", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(common_1.HighriseLitterType),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "typesOfLitterThrown", void 0);
__decorate([
    (0, utils_1.IsSanitizedHtml)({
        isOptional: true,
        sanitizeHtmlOptions: { allowedTags: [] },
    }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "typesOfLitterIfOther", void 0);
__decorate([
    (0, utils_1.IsSanitizedHtml)({
        isOptional: true,
        sanitizeHtmlOptions: { allowedTags: [] },
    }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "descriptionOfOffender", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], SubmitCaseRequestApiDomain.prototype, "suspectedFloorFrom", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], SubmitCaseRequestApiDomain.prototype, "suspectedFloorTo", void 0);
__decorate([
    (0, utils_1.IsString)({ isOptional: true, maxLength: 6 }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "suspectedUnit", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(common_1.SuspectedWindowType, { each: true }),
    __metadata("design:type", Array)
], SubmitCaseRequestApiDomain.prototype, "suspectedWindow", void 0);
__decorate([
    (0, utils_1.IsSanitizedHtml)({
        isOptional: true,
        maxLength: 50,
        sanitizeHtmlOptions: { allowedTags: [] },
    }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "suspectedWindowIfOther", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(common_1.AbandonedTrolleyStore),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "abandonedTrolleyStore", void 0);
__decorate([
    (0, utils_1.IsOptionalIf)((_value, args) => {
        const obj = args.object;
        return obj.category !== common_1.Category.ILLEGAL_PARKING || obj.subCategory === common_1.SubCategory.MOTORCYCLE_AT_VOID_DECK;
    }),
    (0, class_validator_1.IsEnum)(common_1.EIllegalParkingCaseOwner),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "caseOwner", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => common_1.CarParkDetailsDomain),
    (0, utils_1.IsOptionalIf)((_value, args) => {
        const obj = args.object;
        return obj.subCategory !== common_1.SubCategory.HDB_OR_URA_CAR_PARK;
    }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", common_1.CarParkDetailsDomain)
], SubmitCaseRequestApiDomain.prototype, "carParkDetails", void 0);
__decorate([
    (0, utils_1.IsOptionalIf)((_value, args) => {
        const obj = args.object;
        return obj.category !== common_1.Category.ILLEGAL_PARKING || obj.subCategory === common_1.SubCategory.MOTORCYCLE_AT_VOID_DECK;
    }),
    (0, class_validator_1.IsEnum)(common_1.ESubmitTo),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "submitTo", void 0);
__decorate([
    (0, utils_1.IsNumber)({ isOptional: true, max: 99, min: 0 }),
    __metadata("design:type", Number)
], SubmitCaseRequestApiDomain.prototype, "numberOfSmokers", void 0);
__decorate([
    (0, utils_1.IsSanitizedHtml)({
        isOptional: true,
        maxLength: 200,
        sanitizeHtmlOptions: { allowedTags: [] },
    }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "descriptionOfSmokers", void 0);
__decorate([
    (0, utils_1.IsSanitizedHtml)({
        isOptional: true,
        maxLength: 200,
        sanitizeHtmlOptions: { allowedTags: [] },
    }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "detailsOfStallSmoking", void 0);
__decorate([
    (0, utils_1.IsString)({ isOptional: true, maxLength: 9 }),
    __metadata("design:type", String)
], SubmitCaseRequestApiDomain.prototype, "smokerUnitNumber", void 0);
__decorate([
    (0, utils_1.IsNumber)({ isOptional: true, min: 1, max: 99 }),
    __metadata("design:type", Number)
], SubmitCaseRequestApiDomain.prototype, "numberOfBikes", void 0);
//# sourceMappingURL=api-domain.js.map